<template>
    <div id="invoiceDetail">
        <AppBreadCrumb
            :paths="[{ title: $t('billing.invoiceManagement'), path: '/billing' }, { title: 'Fatura Detay' }]"
            :select="true"
        />
        <div class="invoice-detail-content">
            <div class="invoice">
                <div class="invoice-head" style="margin-bottom: 20px">
                    <div class="row-item">
                        <div class="column-item">
                            <div class="title">Site</div>
                            <div class="content">{{ siteName }}</div>
                        </div>
                        <div class="column-item">
                            <div class="title">Billing Period</div>
                            <div class="content">{{ formatDate() }}</div>
                        </div>
                        <div class="column-item" style="width: 30%">
                            <div class="title">Bill Status</div>
                            <div class="content">{{ invoice.paid ? "Ödendi" : "Ödenmedi" }}</div>
                        </div>
                    </div>
                    <div :class="invoice.isManuel && invoice.description ? 'row-item-space-between' : 'row-item-end'">
                        <div class="column-item" v-if="invoice.description">
                            <div class="title">Açıklama</div>
                            <div class="content">{{ invoice.description }}</div>
                        </div>
                        <div class="column-item">
                            <div class="title">Total Price + KDV</div>
                            <div class="content">{{ ~~(invoice.price || 0) }}₺</div>
                        </div>
                    </div>
                </div>

                <div class="invoice-head" style="margin-bottom: 20px" v-if="formatedDetails.length > 0">
                    <div class="row-item">
                        <div class="column-item">
                            <div class="title">Details</div>
                        </div>
                    </div>
                </div>
                <div class="details" v-if="formatedDetails.length > 0">
                    <div class="detail-content" v-for="plan of formatedDetails">
                        <div class="head">
                            <div class="title">
                                {{
                                    title[plan.type] ||
                                    plan.type
                                        .split("-")
                                        .map((c) => c[0].toUpperCase() + c.slice(1).toLowerCase())
                                        .join(" ")
                                }}
                                <span class="ml-1" v-if="isFeature(plan)"> (Özellik) </span>
                            </div>
                            <div class="price">{{ ~~(plan.totalPrice.price || 0) }}₺</div>
                        </div>

                        <!-- -->
                        <div class="content">
                            <div class="detail-content-child" v-for="detail of Object.values(plan.details)">
                                <div class="head">
                                    <div class="title">
                                        <span
                                            >{{ detail.plan.title }} {{ detail.plan.altTitle }}
                                            {{
                                                detail.plan.type === "supsis"
                                                    ? `(${detail.planAction.details.agentCount} Agent) ${
                                                          getFreeAgentCount(detail.plan.features)
                                                              ? `(+${getFreeAgentCount(detail.plan.features)} Ücretsiz)`
                                                              : ""
                                                      }`
                                                    : ["whatsapp-business", "whatsapp"].includes(detail.plan.type)
                                                    ? `(${detail.planAction.details.whatsappChannel} Kanal)`
                                                    : detail.plan.type === "instagram"
                                                    ? `(${detail.planAction.details.instagramChannel} Kanal)`
                                                    : detail.plan.type === "messenger"
                                                    ? `(${detail.planAction.details.messengerChannel} Kanal)`
                                                    : ""
                                            }}</span
                                        >
                                        {{
                                            detail.plan.type === "extra-package"
                                                ? `(${detail.sessionCount} Session)`
                                                : `${detail.startDate} - ${detail.endDate}`
                                        }}
                                    </div>
                                    <div class="price">
                                        {{
                                            plan.type == "chatbot"
                                                ? `${detail.sessionCount} Session`
                                                : (detail.price || 0) > 0
                                                ? `${(detail.price || 0).toFixed(2)}₺`
                                                : ""
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const { getInvoiceById } = require("../../../api/billing");
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";

export default {
    name: "InvoiceDetail",
    components: { AppBreadCrumb },
    data() {
        return {
            siteName: "",
            invoice: {},
            title: {
                supsis: "Live Support",
                chatbot: "Chatbot",
                instagram: "Instagram",
                whatsapp: "Whatsapp",
                telegram: "Telegram",
            },
            formatedDetails: {},
        };
    },
    watch: {},
    methods: {
        formatDate() {
            const startDate = this.$moment(this.invoice.createdDate).startOf("month").format("MMM DD");
            const endDate = this.$moment(this.invoice.createdDate).endOf("month").format("MMM DD, YYYY");
            return `${startDate} - ${endDate}`;
        },
        getFreeAgentCount(features) {
            const feature = features.find((feature) => feature.type == "agent");
            return feature && feature.freeAgentCount;
        },
        formatDetails() {
            const details = this.invoice.details;
            let result = {};
            if (details) {
                const timeBuckets = details.timeBuckets;
                result = Object.keys(timeBuckets).map((type) => {
                    const bucketDetails = timeBuckets[type].reduce((acc, bucket, index) => {
                        const bucketDetail = bucket.details || {};
                        const planAction = details.planActions[bucket.planActionId];
                        const startDate = this.$moment(bucket.date).format("MMM DD YYYY");
                        const endDate = bucket.date && this.$moment(bucket.date).format("MMM DD YYYY");
                        if (planAction.target.type === "extra-package") {
                            acc[planAction.data._id] = {
                                plan: planAction.target,
                                planAction: planAction.data,
                                sessionCount: planAction.target.features[0].maxSessionCount,
                                price: ((acc[planAction.data._id] || {}).price || 0) + bucketDetail.acceptPrice || 0,
                            };
                        } else {
                            acc[planAction.data._id] = {
                                plan: planAction.target,
                                planAction: planAction.data,
                                sessionCount:
                                    ((acc[planAction.data._id] || {}).sessionCount || 0) +
                                        bucketDetail.todayUsageSessionCount || 0,
                                price: ((acc[planAction.data._id] || {}).price || 0) + bucketDetail.acceptPrice || 0,
                                startDate: acc[planAction.data._id]
                                    ? acc[planAction.data._id].startDate
                                    : `${startDate}`,
                                endDate:
                                    (((timeBuckets[type][index + 1] &&
                                        timeBuckets[type][index + 1].planActionId !== planAction.data._id) ||
                                        timeBuckets[type].length == index + 1) &&
                                        endDate) ||
                                    "",
                            };
                        }
                        return acc;
                    }, {});
                    return {
                        type,
                        totalPrice: details.priceDetail[type],
                        details: bucketDetails,
                    };
                });
            }
            this.formatedDetails = result;
        },
        isFeature(planGroups) {
            return Object.values(planGroups.details)[0]?.plan?.type === "feature";
        },
    },
    mounted() {
        getInvoiceById(this.$route.params.id).then((data) => {
            this.invoice = data.invoice;
            this.siteName = data.siteName;
            this.formatDetails();
        });
    },
};
</script>
<style lang="scss" scoped>
#invoiceDetail {
    .invoice-detail-content {
        background: white;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .invoice {
        width: 85vw;
        height: 100vh;
        border: 1px solid #c7d0d7;
        margin-top: 10px;
    }

    .top-head {
        display: flex;
        align-items: top;
        justify-content: space-between;
        margin-top: 10px;

        img {
            width: 200px;
            height: 80px;
        }

        .info {
            display: flex;
            flex-direction: column;
            align-items: end;
            font-weight: bold;
            font-size: 14px;
        }
    }

    .invoice-head {
        padding: 20px 30px;
        background: #f1f4f7;

        .row-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &-end {
                display: flex;
                align-items: center;
                justify-content: flex-end !important;
                margin-top: 20px;
            }
            &-space-between {
                display: flex;
                align-items: center;
                justify-content: space-between !important;
                margin-top: 20px;
            }
        }

        .title {
            font-size: 16px;
        }

        .content {
            font-size: 16px;
            font-weight: 500;
        }
    }

    .details {
        display: flex;
        flex-direction: column;
        justify-content: start;
        padding: 30px;
        padding-top: 0;

        .detail-content {
            user-select: none;
            margin-top: 4px;

            &-child {
                .head {
                    background: none !important;
                    color: black !important;
                    border: none !important;

                    .title {
                        font-weight: normal !important;
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        span {
                            font-weight: 400 !important;
                        }
                    }

                    .price {
                        font-weight: lighter !important;
                        font-size: 12px;
                    }
                }
            }

            .head {
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: black;
                background: #f1f4f7;
                padding: 4px 12px;

                .title {
                    font-weight: bold;
                    font-size: 14px;
                    display: flex;
                    align-items: center;

                    span {
                        color: black;
                        font-weight: bold;
                        margin-right: 10px;
                    }
                }

                .price {
                    font-weight: bold;
                    font-size: 14px;
                }
            }
        }
    }
}
</style>
